import { ITEM_TYPES } from 'bto-models/betslip';
import Vue from 'vue';
/**
 * @typedef {import('../../models/mybets/model-mybet-items').default} MyBetItemsModel
 */
const { OUTRIGHT } = ITEM_TYPES;
/**
 * Map rebet to betslip
 * @param {MyBetItemsModel} bet
 */
export function mapForBetSlip(bet) {
  const itemType = bet.itemTypeId;
  const outcome = {
    id: bet.oddId,
    originalOdd: bet.odd,
    name: bet.outcomeName,
    identifier: bet.identifier,
    specifier: bet.specifier,
    outcome: bet.odd,
    sbv: bet.specialBetValue,
    // Use oddTypeId as playerOddId
    playerOddId: bet.oddTypeId,
    itemType,
    isRaceCast: bet.isRaceCast
    
  };
  const odd = {
    marketId: bet.oddTypeId,
    marketName: bet.market && bet.market.split(':')[0],
    originalOdd: bet.odd,
    competitorId: bet.playerOddTypeId,
  };
  let mNames = {};
  if (itemType !== OUTRIGHT && itemType !== ITEM_TYPES.BOOSTED_ODD && bet.matchTitle) {
    const splitNames = bet.matchTitle.split('vs');
    mNames = {
      homeTeam: splitNames[0].trim(),
      guestTeam: splitNames[1].split('(')[0].trim(),
    };
  }
  const match = {
    tournamentName: bet.tournamentName,
    categoryName: bet.categoryName,
    cashoutAvailable: bet.cashoutAvailable,
    tournamentId: bet.tournamentId,
    categoryId: bet.categoryId,
    sportId: bet.sportId,
    sportName: bet.sportName,
    matchId: bet.matchID,
    name: bet.matchTitle,
    betRadarId: bet.betRadarId,
    eventCode: bet.eventCode,
    outcomeId: bet.oddTypeId,
    ...mNames,
  };

  if (itemType === OUTRIGHT) {
    outcome.oddTypeOutcomeId = bet.oddId;
    outcome.competitorId = bet.playerOddTypeId;
    outcome.id = bet.playerOddTypeId;
    match.id = bet.matchID;
    match.endDate = bet.eventDateString;
  }

  if (itemType === ITEM_TYPES.PLAYER) {
    let oName = '';
    switch (bet.oddTypeId) {
      case (+APP_SETTINGS.playerOdds.first):
        oName = 'Mobile.FirstGoalScorer';
        break;
      case (+APP_SETTINGS.playerOdds.any):
        oName = 'Mobile.AnyGoalScorer';
        break;
      case (+APP_SETTINGS.playerOdds.last):
        oName = 'Mobile.LastGoalscorer';
        break;
    }
    outcome.name = Vue.prototype.$translate.text(oName);
    odd.marketName = bet.outcomeName;
    outcome.id = `p-o-${bet.matchID}-${bet.playerOddTypeId}-${bet.oddId}-${bet.oddTypeId}`;
  }

  return {
    match,
    odd,
    outcome,
    itemType,
  };
}
/**
 * Map rebet to betslip
 * @param {MyBetItemsModel} bet
 */
export function mapBoostedForBetslip(bet, boostedEventIds) {
  const betslip_item = {
    categoryId: bet.categoryId,
    categoryName: bet.categoryName,
    currentOdd: bet.odd.toString(),
    deactivationDate:bet.eventDateString,
    description: bet.oddTypeName,
    eventIds: boostedEventIds,
    id: bet.matchID,
    matchName: bet.matchTitle,
    sport: bet.sportName,
    sportId: bet.sportId,
    tournamentId: bet.tournamentId,
    tournamentName: bet.tournamentName,
    tournamentTemplateId: bet.tournamentId,
  }

  return betslip_item
}
